var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content limit-max daily"},[(_vm.loading)?_c('Loading'):[_c('Ques',{attrs:{"questions":_vm.questions},on:{"submit":_vm.handleSubmit}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }